import React from 'react';
import { ConfirmDialog } from '../../../../components/confirm-dialog';

interface ICancelCourseEnrollmentDialogProps {
  isLoading?: boolean;
  hasStartedLessons?: boolean;
  hasFutureLessons?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function CancelCourseEnrollmentDialog({ onConfirm, onClose, isLoading, hasStartedLessons, hasFutureLessons }: ICancelCourseEnrollmentDialogProps) {
  const futureLessonsSuffix = hasFutureLessons ? ', og borgerens kommende lektioner udgår.' : '.';

  return (
    <ConfirmDialog
      title="Annullér fremmødeforløb?"
      type="warning"
      open
      onConfirmClick={onConfirm}
      onCancelClick={onClose}
      confirmButtonText="Ja, annullér"
      cancelButtonText="Afbryd"
      cancelIsPrimary={false}
      isLoading={isLoading}
    >
      {hasStartedLessons && <p>Afholdte og igangværende lektioner bevares på borgeren. Forløbet afsluttes efter den seneste lektion{futureLessonsSuffix}</p>}
      {!hasStartedLessons && hasFutureLessons && <p>Der er ingen afholdte lektioner, så hele forløbet udgår.</p>}
      <p>Er du sikker på, at du ønsker at annullere fremmødeforløbet?</p>
    </ConfirmDialog>
  );
}
